import L from 'leaflet';

export default class UserPin extends L.Marker
{
	constructor(latlng, options = {})
	{
		const userPinIcon = L.divIcon(
		{
			className: 'user-pin',
			html: `<div class="pin-inner">
						<div class="circle"></div>
					</div>`,
			iconSize: [30, 30]
		}
		);

		super(latlng,
		{
			...options,
			icon: userPinIcon,
			pane: 'user'
		}
		);
	}
}